import { render, staticRenderFns } from "./greenShare.vue?vue&type=template&id=199d74c3&scoped=true"
import script from "./greenShare.vue?vue&type=script&lang=js"
export * from "./greenShare.vue?vue&type=script&lang=js"
import style0 from "./greenShare.vue?vue&type=style&index=0&id=199d74c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199d74c3",
  null
  
)

export default component.exports